export default function StatusFilterModal({
	isOpen,
	onClose,
	selectedStatus,
	onApply,
	statusOptions = [],
	title = 'Filtruj po statusie',
	description = 'Wybierz status, aby zawezic liste.',
	applyLabel = 'Zastosuj',
	clearLabel = 'Wyczysc filtr',
}) {
	if (!isOpen) return null

	return (
		<div className="fixed inset-0 z-50 flex items-center justify-center p-4">
			<div className="absolute inset-0 bg-black/40" onClick={onClose} />
			<div className="relative w-full max-w-md rounded-lg bg-white shadow-xl">
				<div className="border-b border-gray-200 p-4">
					<h3 className="text-base font-semibold text-gray-900">{title}</h3>
					<p className="mt-1 text-sm text-gray-500">{description}</p>
				</div>
				<div className="p-4">
					<ul className="divide-y divide-gray-100 rounded border border-gray-200">
						{statusOptions.map(option => {
							const isActive = selectedStatus === option.value
							return (
								<li key={option.value}>
									<button
										type="button"
										onClick={() => onApply(option.value, option.label)}
										className={`w-full px-3 py-2 text-left text-sm ${
											isActive ? 'bg-blue-50 text-blue-700 font-medium' : 'hover:bg-gray-50 text-gray-700'
										}`}
									>
										{option.label}
									</button>
								</li>
							)
						})}
					</ul>
				</div>
				<div className="flex justify-between border-t border-gray-200 p-4">
					<button
						type="button"
						onClick={() => onApply(null, '')}
						className="rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
					>
						{clearLabel}
					</button>
					<button
						type="button"
						onClick={onClose}
						className="rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
					>
						Anuluj
					</button>
				</div>
			</div>
		</div>
	)
}
